<template>
  <a-modal
    :title="title"
    :visible="hidden"
    :destroyOnClose="true"
    :forceRender="true"
    @cancel="cancel"
    @ok="ok"
    width="500px"
  >
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" >
      <a-form-item label="配方名称">
        {{rowData.formulaName}}
      </a-form-item>
      <a-form-item label="排序">
        <a-input-number
          style="width: 100%;"
          placeholder="请输入"
          v-decorator="['sortNum']"
          :max="999999999"
          :min="-999999999"
        />
        <p style="color: #AAAAAA;margin: 0;line-height: 15px;font-size: 12px;">数字越小越靠前</p>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="ok" :loading="btnLoading">确定</a-button>
    </template>
  </a-modal>
</template>

<script>

//  style={{color: 'gray'}}
import { nhfMixins } from '../../untils'
export default {
  mixins: [nhfMixins],
  props: ['hidden','rowData'],
  data() {
    return {
      title: <p>排序<span style={{color: 'gray',fontSize: '12px'}}>调整配方排序</span></p>,
      form: this.$form.createForm(this),
      btnLoading: false
    }
  },
  watch: {
    hidden(val){
      if(val) {
        let {sortNum} = this.rowData || {}
        console.log('rowData',this.rowData)
        setTimeout(() => {
          this.form.setFieldsValue({sortNum})
        }, 10);
      }
    },
  },
  methods: {
    ok(){
      this.form.validateFields(async (err,values) => {
        let {sortNum} = values || {}
        this.btnLoading = true
        let {id} = this.rowData || {}
        await this.fetchPost({
          actions: this.updateSortNum,
          data: { id,sortNum },
        })
        this.btnLoading = false
        this.$emit('close',true)
      })
    },
    cancel(){
      this.$emit('close',false)
    },
  }
}
</script>